if (!customElements.get('membership-service')) {
    class MembershipService extends HTMLElement {
        constructor() {
            super();

            this.selectors = {
                membershipProductsJSON: '.js-membership-products-json',
                membershipServiceCard: '.js-membership-service-card',
                membershipServiceTabButton: '.js-membership-service-tab-button',
                membershipServiceCardCompareAtPrice: '.js-membership-service-card-compare-at-price',
                membershipServiceCardPrice: '.js-membership-service-card-price',
                membershipServiceCardPriceDuration: '.js-membership-service-card-price-duration',
                membershipServiceCardSellingPlanInput: '.js-membership-service-card-selling-plan-input'
            };

            this.classes = {
                isActive: 'is-active',
                isHidden: 'is-hidden'
            }

            this.membershipProducts = [];
            this.membershipServiceCards = [];
            this.membershipServiceTabButtons = [];
        }

        connectedCallback() {
            this.initMembershipProducts();
            this.initMembershipServiceCards();

            if(!this.membershipProducts.length || !this.membershipServiceCards.length) { return; }

            this.initMembershipServiceTabButtons();
        }

        initMembershipProducts() {
            const membershipProductsJSON = this.querySelector(this.selectors.membershipProductsJSON);

            if(!membershipProductsJSON) { return; }

            try {
                this.membershipProducts = JSON.parse(membershipProductsJSON.innerText).products;
            } catch (error) {
                console.error(`Membership service::ERROR::${error.message}`);
            }
        }

        initMembershipServiceCards() {
            const membershipServiceCards = [...this.querySelectorAll(this.selectors.membershipServiceCard)];

            if(!membershipServiceCards.length) { return; }

            this.membershipServiceCards = membershipServiceCards;
        }

        initMembershipServiceTabButtons() {
            const membershipServiceTabButtons = [...this.querySelectorAll(this.selectors.membershipServiceTabButton)];

            if(!membershipServiceTabButtons.length) { return; }

            this.membershipServiceTabButtons = membershipServiceTabButtons;

            this.membershipServiceTabButtons.forEach(membershipServiceTabButton => {
                membershipServiceTabButton.addEventListener('click', this.handleTabButton.bind(this));
            });
        }

        handleTabButton(event) {
            const membershipServiceTabButton = event.target.closest(this.selectors.membershipServiceTabButton);
            const optionValueHandle = membershipServiceTabButton.dataset.optionValueHandle;

            if (!optionValueHandle) { return; }

            this.updateMembershipProducts(optionValueHandle);

            const membershipServiceTabButtonActive = this.membershipServiceTabButtons.find(membershipServiceTabButton => membershipServiceTabButton.classList.contains(this.classes.isActive));

            membershipServiceTabButtonActive && membershipServiceTabButtonActive.classList.remove(this.classes.isActive);
            membershipServiceTabButtonActive && (membershipServiceTabButtonActive.disabled = false);

            membershipServiceTabButton.classList.add(this.classes.isActive);
            membershipServiceTabButton.disabled = true;
            membershipServiceTabButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

            const tabBadge = membershipServiceTabButton.querySelector('.memberships__tab-badge');
            const sectionBadge = this.querySelector(':scope > .memberships__tab-badge');
            if (sectionBadge) {
                if (tabBadge) {
                    sectionBadge.textContent = tabBadge.textContent;
                    sectionBadge.style.display = '';
                } else {
                    sectionBadge.style.display = 'none';
                }
            }
        }

        updateMembershipProducts(optionValueHandle) {
            const membershipProducts = this.membershipProducts
                .flatMap(membershipProducts =>
                    membershipProducts.sellingPlanAllocations
                        .filter(sellingPlanAllocation => sellingPlanAllocation.optionValueHandle === optionValueHandle)
                        .map(sellingPlanAllocation => ({
                            productId: membershipProducts.productId,
                            sellingPlanAllocation
                        })
                    )
                );

            this.updateMembershipServiceCards(membershipProducts);
        }

        updateMembershipServiceCards(membershipProducts) {
            this.membershipServiceCards.forEach(membershipServiceCard => this.updateMembershipServiceCard(membershipServiceCard, membershipProducts));
        }

        updateMembershipServiceCard(membershipServiceCard, membershipProducts) {
            const membershipServiceCardId = Number(membershipServiceCard.dataset.productId);
            const relatedMembershipProduct = membershipProducts.find(membershipProduct => membershipProduct.productId === membershipServiceCardId);

            if(!relatedMembershipProduct) {
                membershipServiceCard.classList.add(this.classes.isHidden);
                return;
            }

            const sellingPlanInput = membershipServiceCard.querySelector(this.selectors.membershipServiceCardSellingPlanInput);
            if (sellingPlanInput) {
                sellingPlanInput.value = relatedMembershipProduct.sellingPlanAllocation.id;
            }

            const membershipServiceCardCompareAtPrice = membershipServiceCard.querySelector(this.selectors.membershipServiceCardCompareAtPrice);
            const membershipServiceCardPrice = membershipServiceCard.querySelector(this.selectors.membershipServiceCardPrice);
            const membershipServiceCardPriceDuration = membershipServiceCard.querySelector(this.selectors.membershipServiceCardPriceDuration);

            const perDeliveryCompareAtPrice = relatedMembershipProduct.sellingPlanAllocation.perDeliveryCompareAtPrice;
            const perDeliveryPrice = relatedMembershipProduct.sellingPlanAllocation.perDeliveryPrice;
            const priceDuration = relatedMembershipProduct.sellingPlanAllocation.priceDuration;

            if (membershipServiceCardCompareAtPrice) {
                membershipServiceCardCompareAtPrice.classList.toggle(this.classes.isHidden, !perDeliveryCompareAtPrice);
                membershipServiceCardCompareAtPrice.innerText = perDeliveryCompareAtPrice;
            }

            if (membershipServiceCardPrice) {
                membershipServiceCardPrice.innerText = perDeliveryPrice;
            }

            if (membershipServiceCardPriceDuration) {
                membershipServiceCardPriceDuration.classList.toggle(this.classes.isHidden, !priceDuration);
                membershipServiceCardPriceDuration.innerHTML = priceDuration;
            }

            membershipServiceCard.classList.remove(this.classes.isHidden);
        }
    }

    customElements.define('membership-service', MembershipService)
}